module.exports = __webpack_public_path__ + "static/media/facebook.bff8208a.svg";